
import AdminLayout from "../../../layouts/admin/Layout"

import DashboardPage from "../pages/admin/dashboard/DashboardPage"

import ContainersPage from "../pages/admin/repositories/containers/ContainersPage"
import ContainerNewPage from "../pages/admin/repositories/containers/ContainerNewPage"
// import ContainerUpdatePage from "../pages/admin/repositories/containers/ContainerUpdatePage"
import ContainerModifyPage from "../pages/admin/repositories/containers/ContainerModifyPage"
// import ContainerModifyNewPage from "../pages/admin/repositories/containers/ContainerModifyNewPage"
// import ImportPackingExcelPage from "../pages/admin/repositories/containers/bk_ImportPackingExcelPage"

import CustomersPage from "../pages/admin/users/customers/CustomersPage"
import CustomerNewPage from "../pages/admin/users/customers/CustomerNewPage"
import CustomerUpdatePage from "../pages/admin/users/customers/CustomerUpdatePage"
import MarkingsPage from "../pages/admin/users/customers/MarkingsPage"

import ProductsPage from "../pages/admin/products/ProductsPage"
import ProductNewPage from "../pages/admin/products/ProductNewPage"
import ProductUpdatePage from "../pages/admin/products/ProductUpdatePage"
import ProductChangeOwnerPage from "../pages/admin/products/ProductChangeOwnerPage"

import ContainersReportPage from "../pages/admin/reports/ContainersReportPage"
import ProductsReportPage from "../pages/admin/reports/ProductsReportPage"
import ProductItemsReportPage from "../pages/admin/reports/ProductItemsReportPage"

import ConfigurationPage from "../pages/admin/ConfigurationPage"

import DemoDatagridPage from "../pages/admin/DemoDatagridPage"

export default function routes() {

    return [
        {
            path: '/admin',
            element: <AdminLayout />,
            children: [

                { path: '', element: <DashboardPage /> },
                { path: 'dashboard', element: <DashboardPage /> },

                { path: 'repositories/container/new', element: <ContainerNewPage /> },
                { path: 'repositories/containers', element: <ContainersPage /> },
                // { path: 'repositories/container/update/:id', element: <ContainerUpdatePage /> },
                { path: 'repositories/container/modify/:id', element: <ContainerModifyPage /> },
                // { path: 'repositories/container/modify/new/:id', element: <ContainerModifyNewPage /> },
                // { path: 'repositories/container/importPackingExcel', element: <ImportPackingExcelPage /> },

                { path: 'users/customers', element: <CustomersPage /> },
                { path: 'users/customer/new', element: <CustomerNewPage /> },
                { path: 'users/customer/update/:id', element: <CustomerUpdatePage /> },
                { path: 'users/customers/markings', element: <MarkingsPage /> },

                { path: 'products/items', element: <ProductsPage /> },

                { path: 'product/new', element: <ProductNewPage /> },
                // { path: 'product/new/direct', element: <ProductNewDirectPage /> },
                { path: 'product/update/:id', element: <ProductNewPage /> },
                // { path: 'product/item/view/:id', element: <ProductViewPage /> },
                { path: 'product/item/update/:id', element: <ProductUpdatePage /> },
                { path: 'product/changeOwner', element: <ProductChangeOwnerPage /> },

                // { path: 'items/parcel/new', element: <ParcelNewPage /> },

                { path: 'configuration', element: <ConfigurationPage /> },
                // { path: 'demodatagrid', element: <DemoDatagridPage /> },

                { path: 'reports/containers', element: <ContainersReportPage /> },
                { path: 'reports/products', element: <ProductsReportPage /> },
                { path: 'reports/productItems', element: <ProductItemsReportPage /> },

            ],
        }
    ]
}